<div class="shares-number-container">
  <div [ngClass]="{'number': hasIssue}">{{ numberOfShares | currency: '': '': '1.0' }}</div>
  @if(hasIssue) {
    <div class="asic-number">(ASIC) {{ numberOfSharesAsic | currency: '': '': '1.0' }}</div>
  }
</div>
